<div #trigger (mouseleave)="onMouseLeave($event, popover)" (mouseover)="onMouseHover()"
  class="operation-popover-trigger">
  <ng-content select="[slot='trigger']"></ng-content>
</div>

<fw-popover #popover [trigger]="trigger" position="above" action="mouseenter">
  <div class="operation-popover">
    <div class="operation-popover-list">
      <ng-container *ngFor="let key of config">
        <div *ngIf="data[key]" class="operation-popover-list-item">
          <span class="operation-popover-list-item-key">{{ getFieldKey(key) | translate }}</span>
          <fw-tooltip class="operation-popover-list-item-tooltip" [title]="isTooltip(key) ? data[key] : ''">
            <span *ngIf="key !== OperationPopoverFields.JobSchedule; else cron" [ngStyle]="{maxWidth}"
              class="operation-popover-list-item-value">{{ dateFields.includes(key) ? (data[key] | date: dateMask ) : data[key]}}</span>
            <ng-template #cron>
              <span [ngStyle]="{maxWidth}" class="operation-popover-list-item-value"> {{humanReadableCron}}
                ({{data[key]}})</span>
            </ng-template>
          </fw-tooltip>
        </div>
      </ng-container>
    </div>
    <ng-content select="[slot='footer']"></ng-content>
  </div>
</fw-popover>
